/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popPphTip.vue?vue&type=template&id=c5ffd28e&scoped=true"
import script from "./popPphTip.vue?vue&type=script&lang=js"
export * from "./popPphTip.vue?vue&type=script&lang=js"
import style0 from "./popPphTip.vue?vue&type=style&index=0&id=c5ffd28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ffd28e",
  null
  
)

export default component.exports